import { SimpleGrid, Container, Divider, Box } from '@hover/blueprint';
import React, { useState, useEffect } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import EstimationHeader from './EstimationHeader';
import CollapseItem from './CollapseItem';
import ClaimEstimationLearnMoreButton from './ClaimEstimationLearnMoreButton';

const ANIMATION_DURATION = 6.35;

const ClaimsEstimationDesktop: React.FC = () => {
  const [showTopCollapse, setShowTopCollapse] = useState<boolean>(true);

  useEffect(() => {
    const unsub = setInterval(
      () => setShowTopCollapse(prevState => !prevState),
      ANIMATION_DURATION * 1000,
    );

    return () => clearInterval(unsub);
  }, []);

  return (
    <SimpleGrid
      d={{ base: 'none', desktop: 'grid' }}
      columns={2}
      alignItems="center"
      spacing="83px"
    >
      <Container maxW="xl">
        <Box d={showTopCollapse ? 'flex' : 'none'}>
          <StaticImage
            quality={100}
            placeholder="blurred"
            alt="easy imports"
            src="../../../assets/images/insurance_easy_import.png"
          />
        </Box>
        <Box d={!showTopCollapse ? 'flex' : 'none'}>
          <StaticImage
            quality={100}
            placeholder="blurred"
            alt="real time 3d"
            src="../../../assets/images/insurance_fast_estimation.png"
          />
        </Box>
      </Container>
      <Container maxW="xl">
        <EstimationHeader mb={{ base: 600, tablet: 800 }} />
        <Box flexDir="column" overflow="hidden" maxH="330px">
          <CollapseItem
            isActive={showTopCollapse}
            content="Import 3D model data and accurate measurements directly into your claims
           management tool of choice. No manual sketching required."
            title="Easy Imports"
          />
          <CollapseItem
            isActive={!showTopCollapse}
            content="Better measurements means more accurate estimations.
           Minimize errors and settle property claims quickly and more accurately."
            title="Better Estimates"
            body="Create precise estimates in Xactimate with our .esx file outputs, or
           connect directly with Symbility or Filetrac."
          />
        </Box>
        <Divider color="neutral.300" mt={showTopCollapse ? 0 : 500} />
        <ClaimEstimationLearnMoreButton />
      </Container>
    </SimpleGrid>
  );
};

export default ClaimsEstimationDesktop;
